import { Box, Flex, Text, Transition } from '@mantine/core';
import { LoadingAnimation } from 'src/UI/app-container/chat/components/LoadingAnimation';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './EditingOverlay.module.css';

const slideUpFade = {
  in: { opacity: 1, transform: 'translateY(0)' },
  out: { opacity: 0, transform: 'translateY(20px)' },
  common: { transformOrigin: 'bottom' },
  transitionProperty: 'opacity, transform',
};

export function EditingOverlay({ mounted }: { mounted: boolean }) {
  return (
    <Transition mounted={mounted} transition={slideUpFade} duration={350} timingFunction="ease-out">
      {(styles: React.CSSProperties) => (
        <Flex
          pos="absolute"
          direction="column"
          align="center"
          justify="flex-end"
          pb="xxxxl"
          style={{
            ...styles,
            top: 0,
            left: 'calc(-1 * var(--mantine-spacing-xxl))',
            right: 'calc(-1 * var(--mantine-spacing-xxl))',
            bottom: 'calc(-1 * var(--mantine-spacing-lg))',
            zIndex: 100,
            overflow: 'hidden',
            borderRadius: '0 0 var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          }}
        >
          <Box className={classes.videoWrapper}>
            <video autoPlay loop muted playsInline className={classes.maskedVideo}>
              <source src="/sidebar-background.mp4" type="video/mp4" />
            </video>
          </Box>

          <Box pos="relative" style={{ zIndex: 1, textAlign: 'center' }}>
            <LoadingAnimation color="white" size={48} />
            <Text size="displayXs" fw={FONT_WEIGHTS.semibold} c="white">
              Applying the changes
            </Text>
          </Box>
        </Flex>
      )}
    </Transition>
  );
}
